import { foundationContext, ParameterValue } from '@philips-internal/oswald-ui-foundation';

export class FoundationUtils {

  /**
   * Verify if has module in foundation module
   * @param moduleId string
   * @param param string
   * @returns boolean
   */
  public static hasModuleParam = (moduleId: string, param: string): boolean => {
    const module = foundationContext.getModule(moduleId);
    const paramItem = module?.parameters.get(param);
    return !!module && !!paramItem;
  }

  /**
   * Find module, this method find Foundation Module, which is the parameter set as default
   * @param moduleId string
   * @param param string
   * @returns ParameterValue
   */
  static findModuleParam = (moduleId: string, param: string): ParameterValue | null => {
    if (FoundationUtils.hasModuleParam(moduleId, param)) {
      return foundationContext.getModuleParameter(moduleId, param);
    }

    return null
  }

}
